import { useLocation } from "react-router-dom";
import { UserStatus } from "../../../constants/constants";
import ConflictStaffList from "./ConflictStaffList";
import StaffListComponent from "./StaffListComponent";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { set } from "date-fns";

const StaffList = () => {
  const location = useLocation();
  const statuskey = useSelector((state: RootState) => state.staffListData.key);
  const [key, setKey] = useState<string | null>(statuskey);
  useEffect(() => {
    setKey(statuskey);
  }, [statuskey]);
  return (
    <>
      <div className="bg-dashboardBackgroundColor  pb-10">
        <div className=" flex ">
          <div className="px-4 md:px-4 lg:px-8 pt-4 w-full ">
            {key === UserStatus.CONFLICT ? (
              <ConflictStaffList statusKey={key} />
            ) : (
              <StaffListComponent statusKey={key} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default StaffList;
